import React from 'react'
function SearchFilter(props) {
  const {
    setDropDownsDisable,
    setOnSearchingFilterDropDownsDisable,
    searchedValue,
    disableInputOnDropDownSelect,
    searchDisableOnDropDownSelect,
    setSearchedValue,
    setTotalRenderedCount,
    SetsearchDisableOnDropDownSelect,
    filterBYSearch,
    getListMoviesData,
    status,
  } = props

  const resetBySearch = () => {
    SetsearchDisableOnDropDownSelect(true)

    setOnSearchingFilterDropDownsDisable(false)
    setTotalRenderedCount(10)
    setSearchedValue('')
    getListMoviesData('all')
  }

  const searchFilterData = e => {
    if (e.target.value === '') {
      resetBySearch()
    } else {
      setDropDownsDisable(e.target.value.length > 0)
      SetsearchDisableOnDropDownSelect(e.target.value.length < 3)
      setOnSearchingFilterDropDownsDisable(e.target.value.length > 0)
      setTotalRenderedCount(10)
      // console.log(e.target.value)
      setSearchedValue(e.target.value)
    }
  }

  // console.log(searchDisableOnDropDownSelect, 'searchDisableOnDropDownSelect')
  return (
    <div>
      <input
        disabled={disableInputOnDropDownSelect || status === 'draft'}
        value={searchedValue}
        onChange={searchFilterData}
      />
      <button
        disabled={searchDisableOnDropDownSelect /* || dropDownDisableOnSearch */}
        className='btn btn-primary m-2'
        onClick={filterBYSearch}
      >
        Search
      </button>
      <button className='btn btn-primary m-1' onClick={resetBySearch}>
        Clear
      </button>
    </div>
  )
}

export default SearchFilter
